import { render } from "./Cloture.vue?vue&type=template&id=6b848981&scoped=true"
import script from "./Cloture.vue?vue&type=script&lang=js"
export * from "./Cloture.vue?vue&type=script&lang=js"

import "./Cloture.vue?vue&type=style&index=0&id=6b848981&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b848981"]])

export default __exports__